import PropTypes from 'prop-types';

import { FormGroup, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { Label } from '../atoms/labels';

const Title = ({ title }) => {
  if (!title) {
    return;
  }

  return <Label label={title} sx={{ mr: 2 }} />;
};
Title.propTypes = {
  title: PropTypes.string
};

const Description = ({ desc }) => {
  if (!desc) {
    return;
  }

  return (
    <Typography
      variant="p"
      sx={{ mt: '-6px', ml: 6, minWidth: 128, fontSize: '.875rem', color: (theme) => theme.palette.grey[500] }}
    >
      {desc}
    </Typography>
  );
};
Description.propTypes = {
  desc: PropTypes.string
};

const SwitchCustom = (props) => {
  const { checked, desc = '', label = '', title = '', onClick, id } = props;

  const handleChange = (event) => {
    onClick(event.target.checked);
  };

  return (
    <FormGroup sx={{ display: 'flex', flexFlow: 'row nowrap', alignItems: 'center' }}>
      <Title title={title} />
      <Stack direction="column">
        <FormControlLabel
          style={{ pointerEvents: 'none' }}
          id={id}
          control={
            <Switch
              style={{ pointerEvents: 'auto' }}
              checked={checked || false}
              onClick={(event) => handleChange(event)}
            />
          }
          label={label}
        />
        <Description desc={desc} />
      </Stack>
    </FormGroup>
  );
};
SwitchCustom.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  label: PropTypes.string,
  desc: PropTypes.string,
  onClick: PropTypes.func,
  checked: PropTypes.bool
};

export default SwitchCustom;
